var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-trans-details" },
    [
      _c(
        "div",
        { staticClass: "filter-section-container" },
        [
          _c("div", { staticClass: "filter-fixed" }, [
            _c("span", { staticClass: "filter-fixed-title" }, [
              _vm._v(_vm._s(_vm.$t("data.filter_section"))),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down filter-fixed-arrow",
              class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
              on: { click: _vm.onClickFixedArrow },
            }),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilterContent,
                    expression: "showFilterContent",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.create_time,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "create_time", $$v)
                            },
                            expression: "search.create_time",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "filter-item",
                        class: { "border-red": _vm.isShowBorderRed },
                      },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("merchantAccount.complete_time")) +
                              " "
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.return_time,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "return_time", $$v)
                            },
                            expression: "search.return_time",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search.channel_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "channel_code", $$v)
                              },
                              expression: "search.channel_code",
                            },
                          },
                          _vm._l(
                            _vm.compFilterPaymentChannel,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.channel_code,
                                  value: item.channel_code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.original_transaction_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", size: "small", clearable: "" },
                          model: {
                            value: _vm.search.original_transaction_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.search,
                                "original_transaction_id",
                                $$v
                              )
                            },
                            expression: "search.original_transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.mch_refund_order_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", size: "small", clearable: "" },
                          model: {
                            value: _vm.search.mch_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "mch_order_id", $$v)
                            },
                            expression: "search.mch_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerService.refund_transaction_id")
                            )
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.refund_transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "refund_transaction_id", $$v)
                            },
                            expression: "search.refund_transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("customerService.refund_type"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search.refund_category,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "refund_category", $$v)
                              },
                              expression: "search.refund_category",
                            },
                          },
                          _vm._l(_vm.refundStatusMap, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.refund_status"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "status", $$v)
                              },
                              expression: "search.status",
                            },
                          },
                          _vm._l(_vm.refundTypeMap, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filter-item" }),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c(
                    "div",
                    { staticClass: "filter-operate-left" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10 download-btn",
                          attrs: {
                            loading: _vm.downloading,
                            type: "info",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.onClickDowmloadBtn },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.download")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { size: "small" },
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "total-container" }, [
        _c("div", { staticClass: "total-item" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.total_count")) + ": "),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(_vm._s(_vm.summaryData.total_refund_count)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("customerService.full_refund_summary")) + ": "
          ),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(_vm.summaryData.total_refund_amount)
                )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("customerService.return_fee_summary")) + ": "
          ),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(
                    Math.abs(_vm.summaryData.total_fee_refunded)
                  )
                )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("customerService.total_refund_fee")) + ": "
          ),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(
                    Math.abs(_vm.summaryData.total_refund_fee)
                  )
                )
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.original_transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.original_transaction_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.mch_refund_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.mch_order_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.refund_transaction_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.payment_type"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getproductCategoryMap(
                                scope.row.product_category
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchant.payment_channel"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.refund_type"),
                  align: "center",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-wrap" },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "payin-status tag-custom",
                                attrs: {
                                  type: _vm.getRefundStatusMapType(
                                    scope.row.refund_category
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getRefundStatusMap(
                                        scope.row.refund_category
                                      )
                                    )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.original_transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("toDivideWithDot")(
                                  scope.row.original_transaction_amount
                                )
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_order_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.this_time_refund_amount
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refunded_transaction_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                Math.abs(scope.row.refund_transaction_fee)
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                Math.abs(scope.row.actual_receive_refund_amount)
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("customerService.refund_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.refund_fee)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "160",
                  label: _vm.$t("customerService.refund_status"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "payin-status tag-custom",
                            attrs: {
                              type: _vm.getRefundTypeMapType(scope.row.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getRefundTypeMap(scope.row.status))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_create_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_return_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  label: _vm.$t("components.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailTxt(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("components.operation"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                  ]
                                ),
                                _c("svg-icon", {
                                  attrs: {
                                    "class-name": "icon-function",
                                    "icon-class": "operation-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClickRefundTxt(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("refund-details-modal", {
        ref: "refundDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
      _c("refund-modal", {
        ref: "refundModal",
        attrs: { "detail-id": _vm.detailId },
        on: { updateList: _vm.handleFilter },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }